import { render, staticRenderFns } from "./RegCard.vue?vue&type=template&id=194b9639&scoped=true"
import script from "./RegCard.vue?vue&type=script&lang=js"
export * from "./RegCard.vue?vue&type=script&lang=js"
import style0 from "./RegCard.vue?vue&type=style&index=0&id=194b9639&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194b9639",
  null
  
)

export default component.exports